import React from "react";
import { Helmet } from "react-helmet-async";
import ParticlesBackground from "./ParticlesBackground";
import "./ProductHero.css";
import DesignImage from "./images/Software-IT-Services-Transparent-PNG.png";

const ProductHero = ({ isDarkMode }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "AstraSight Technologies Products",
    brand: {
      "@type": "Brand",
      name: "AstraSight Technologies",
    },
    description:
      "Explore innovative software products developed by AstraSight Technologies including JibuBot and other upcoming digital tools tailored for businesses in Africa.",
    url: "https://astrasighttech.com/products",
    image: "https://astrasighttech.com/images/products-banner.png",
  };

  return (
    <>
      <Helmet>
        <title>Our Products – AstraSight Technologies | JibuBot & More</title>
        <meta
          name="description"
          content="Explore AstraSight Technologies' innovative digital products, including JibuBot – the intelligent chatbot solution for African businesses."
        />
        <meta
          name="keywords"
          content="AstraSight Technologies products, JibuBot, chatbot solutions, digital tools Africa, IT products"
        />
        <meta name="author" content="AstraSight Technologies" />

        <meta property="og:title" content="Our Products – AstraSight Technologies | JibuBot & More" />
        <meta
          property="og:description"
          content="Discover AstraSight Technologies' line of software products including the AI-powered JibuBot for smart business automation."
        />
        <meta property="og:image" content="https://astrasighttech.com/images/products-banner.png" />
        <meta property="og:url" content="https://astrasighttech.com/products" />

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section className={`heroabout ${isDarkMode ? "dark" : "light"}`}>
        {/* 🌐 SHARED PARTICLES BACKGROUND */}
        <ParticlesBackground isDarkMode={isDarkMode} />

        <div className="heroabout-content">
          <div className="content-left">
            <div className="vertical-line product"></div>
            <div className="text-container">
              <h1 className="about-heading">
                Our Products – Crafted by AstraSight Technologies
              </h1>
              <p className="about-paragraph">
                Discover innovative digital products built to{" "}
                <strong>transform businesses across Africa.</strong>
                <br />
                <br />
                🚀 <strong>JibuBot</strong> – our intelligent chatbot assistant is
                just the beginning.
                <br />
                <br />
                💡 Powerful, secure, and scalable tools—designed for growth.
              </p>
            </div>
          </div>

          <div className="image-container">
            <img
              className="about-image"
              src={DesignImage}
              alt="AstraSight Technologies Product Showcase - JibuBot and More"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductHero;
